import * as ko from "knockout";
import {PersonaliaModel} from "./PersonaliaModel";
import {IModelParams} from "./index";

export class PersonaliaModelCreate extends PersonaliaModel {

    constructor(params: IModelParams) {
        super(params)

        this.derived.SourceId = ko.pureComputed(() => {
            return this.attr.EmployeeNumber?.() ?? null
        })

    }
    public override initErrorObjects() {
        super.initErrorObjects()

        this.eo.Socialsecuritynumber?.addValidator({
            fn: () => this.attr.Socialsecuritynumber?.() != this.attr.EmployeeNumber?.(),
            message: () => {
                const x = this.srcTrans('Socialsecuritynumber')
                const y = this.srcTrans('EmployeeNumber')
                return `x and y can not be equal|x:${x}|y:${y}`
            },
            prerequisite: () => !!this.attr.Socialsecuritynumber?.(),
        })

        this.eo.EmployeeNumber?.addValidator({
            fn: () => this.attr.Socialsecuritynumber?.() != this.attr.EmployeeNumber?.(),
            message: () => {
                const x = this.srcTrans('Socialsecuritynumber')
                const y = this.srcTrans('EmployeeNumber')
                return `x and y can not be equal|x:${x}|y:${y}`
            },
            prerequisite: () => !!this.attr.EmployeeNumber?.(),
        })
    }
}
